import { getApiClient } from './apiClient'

export const fn = async (personId: number): Promise<{ eventId: number }> => {
  const response = await getApiClient().get(`participants/person/${personId}/plus/events/latest`)
  return response.data.data
}

export default fn
